import classnames from 'classnames';
import { upperFirst } from 'lodash';
import { mergeStyles, getRelValue, normalizeHref } from 'wix-rich-content-common';
import React, { useMemo, useCallback, Component } from 'react';
import PropTypes from 'prop-types';
import { Node_Type } from 'ricos-schema';

const LINK_BUTTON_TYPE = "wix-draft-plugin-link-button";
const ACTION_BUTTON_TYPE = "wix-draft-plugin-action-button";

var alignmentStyles = {"button_align_left":"CW4j2","button_align_right":"L8VoW","button_align_center":"weqz-"};

var Styles = {"button_container":"JtcTL","button_text":"QUyvQ","button_size_content":"hfHdG"};

const alignmentClassName = (componentData, theme, styles2) => {
  const { alignment = "center" } = componentData.config || {};
  const mergedStyles = mergeStyles({ styles: alignmentStyles, theme });
  return classnames(
    mergedStyles[`button_align_${alignment}`],
    styles2[`align${upperFirst(alignment)}`],
    theme[`align${upperFirst(alignment)}`]
  );
};
const sizeClassName = (componentData, theme) => {
  const mergedStyles = mergeStyles({ styles: Styles, theme });
  return mergedStyles.button_size_content;
};

var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
const ButtonViewer$1 = ({
  style,
  anchorTarget,
  onClick,
  theme,
  helpers,
  url,
  target = anchorTarget,
  rel,
  buttonText
}) => {
  const styles = mergeStyles({ styles: Styles, theme });
  const isActionButton = useMemo(() => Boolean(onClick), [onClick]);
  const onClickHandler = useCallback(
    (args) => {
      var _a;
      (_a = helpers.onViewerAction) == null ? void 0 : _a.call(helpers, isActionButton ? ACTION_BUTTON_TYPE : LINK_BUTTON_TYPE, "Click", "");
      if (isActionButton) {
        onClick == null ? void 0 : onClick(args);
      }
    },
    [helpers.onViewerAction]
  );
  const Component = isActionButton ? "div" : "a";
  return /* @__PURE__ */ React.createElement(
    Component,
    __spreadValues$3({
      className: styles.button_container,
      style,
      "data-hook": "buttonViewer",
      onClick: onClickHandler,
      tabIndex: 0,
      role: "button",
      onKeyDown: (e) => {
        if (e.key === " " || e.key === "Enter") {
          e.preventDefault();
          onClickHandler(e);
        }
      }
    }, !isActionButton && { href: url, target, rel: getRelValue(rel) }),
    /* @__PURE__ */ React.createElement("div", { className: styles.button_text }, buttonText)
  );
};

var __defProp$2 = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp$2(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class ButtonComponent extends Component {
  render() {
    var _a, _b, _c, _d;
    const {
      componentData: { button, config },
      settings: { onClick, themeData },
      config: buttonConfig,
      helpers,
      anchorTarget,
      theme
    } = this.props;
    const { colors: { actionColor, bgColor } = {} } = themeData || (buttonConfig == null ? void 0 : buttonConfig.themeData) || {};
    const buttonText = button.settings.buttonText;
    const url = (_a = button.settings) == null ? void 0 : _a.url;
    let linkButtonSettings = {};
    if (url) {
      linkButtonSettings = {
        url: normalizeHref(url),
        target: button.settings.target,
        rel: button.settings.rel
      };
    }
    const style = __spreadProps(__spreadValues$2(__spreadValues$2({
      border: "0px solid blue",
      color: ((_b = this.props.settings.colors) == null ? void 0 : _b.color1) || bgColor,
      background: ((_c = this.props.settings.colors) == null ? void 0 : _c.color8) || actionColor,
      borderColor: ((_d = this.props.settings.colors) == null ? void 0 : _d.color8) || actionColor
    }, this.props.style), button.design), {
      width: `min(100%, ${config == null ? void 0 : config.width}px)`
    });
    return /* @__PURE__ */ React.createElement(
      ButtonViewer$1,
      __spreadValues$2({
        style,
        buttonText,
        theme,
        onClick,
        helpers,
        anchorTarget
      }, linkButtonSettings)
    );
  }
}
__publicField(ButtonComponent, "alignmentClassName", (componentData, theme, styles, isMobile) => alignmentClassName(componentData, theme, styles));
__publicField(ButtonComponent, "sizeClassName", (componentData, theme, styles, isMobile) => sizeClassName(componentData, theme));
ButtonComponent.propTypes = {
  componentData: PropTypes.object,
  style: PropTypes.object,
  anchorTarget: PropTypes.string,
  settings: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  helpers: PropTypes.object,
  config: PropTypes.object
};
var ButtonViewer = ButtonComponent;

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
const buttonTypeObj = {
  component: ButtonViewer,
  classNameStrategies: { alignment: alignmentClassName, size: sizeClassName }
};
const typeMapper = () => ({
  [LINK_BUTTON_TYPE]: __spreadValues$1({}, buttonTypeObj),
  [ACTION_BUTTON_TYPE]: __spreadValues$1({}, buttonTypeObj)
});

const ALIGN_CENTER = "center";
const DEFAULT_CONFIG = {
  alignment: ALIGN_CENTER,
  size: "small",
  width: "fit-content"
};
({
  settings: {
    [ACTION_BUTTON_TYPE]: `${Node_Type.BUTTON}.actionButtonSettings`,
    [LINK_BUTTON_TYPE]: `${Node_Type.BUTTON}.linkButtonSettings`
  },
  alignment: {
    [ACTION_BUTTON_TYPE]: `${Node_Type.BUTTON}.actionButtonAlignment`,
    [LINK_BUTTON_TYPE]: `${Node_Type.BUTTON}.linkButtonAlignment`
  }
});

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginButton = (type, config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULT_CONFIG), config),
    type,
    typeMapper
    // nodeViewRenderers,
  };
};
const pluginLinkButton = (config) => {
  return pluginButton(LINK_BUTTON_TYPE, config);
};
const pluginActionButton = (config) => {
  return pluginButton(ACTION_BUTTON_TYPE, config);
};

export { ACTION_BUTTON_TYPE, LINK_BUTTON_TYPE, typeMapper as buttonTypeMapper, pluginActionButton, pluginLinkButton };
//# sourceMappingURL=viewer.js.map

import 'wix-rich-content-plugin-button/dist/es/styles.viewer.min.global.css'